export const verifyArray = (array: any[]) => {
  if (!array || !array.length) {
    return null;
  }

  return array;
};
